import Payments from './Payments';

export default class StripePayment extends Payments {
  async intent(params = {}) {
    const { paymentMethodTypes, isDigital, clientSecret } = params;
    
    // Always read from the Vuex store for the freshest cart data
    const storeCart = this.auth?.ctx?.store?.state?.cart;
    const currentCart = storeCart || this.cart || {};
    
    // Allow manual amount override if passed in params, otherwise use cart total
    const amount = params.amount || Math.round(Number(currentCart?.Total?.ToPay?.TaxIncl || 0) * 100);
    const currency = currentCart?.Currency?.IsoCode || currentCart?.Total?.ToPay?.CurrencyIsoCode;

    if (amount <= 0 || !currency) {
      console.warn('[StripePayment] Skip intent: Invalid amount or currency', { amount, currency });
      return {};
    }

    const formData = new FormData();
    if (clientSecret) {
      formData.append('ClientSecret', clientSecret);
    }
    formData.append('Amount', amount);
    formData.append('CurrencyIsoCode', currency);
    formData.append('PaymentMethodTypes', paymentMethodTypes || 'card');
    if (isDigital) {
      formData.append('IsDigital', '1');
    }

    try {
      const response = await this.http.API_AUTH.post(
        '/payment/stripe/intent',
        formData
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      throw error;
    }
  }

  async postData({ clientSecret, paymentMethod }) {
    var FormData = require('form-data');
    var formData = new FormData();

    formData.append('ClientSecret', clientSecret);
    formData.append(
      'Metadata',
      JSON.stringify(this.custom_data(paymentMethod))
    );

    try {
      const response = await this.http.API_AUTH.post(
        '/payment/stripe/data',
        formData
      );
      if (response.status === 200) {
        return response;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      throw new Error(error.message);
    }
  }
}
